import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("adminToken");

  if (!token) {
    // No está loggeado
    return <Navigate to="/admin/login" replace />;
  }

  // Está loggeado, mostrar el children (el Dashboard)
  return children;
}

export default ProtectedRoute;
